import Decimal from 'decimal.js';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';

export const canEditCargoTemperature = (cargoOperation: RotationCargoOperation): boolean => {
    return !!cargoOperation;
};

export const calculateVolumeFromLitreWeight = (weight: Decimal, litreWeight: Decimal): Decimal => {
    // TODO: DIVISION-BY-ZERO - No division by zero check - if litreWeight is zero, dividedBy will throw an error or return Infinity. Should validate litreWeight > 0 before division.
    return weight.dividedBy(litreWeight).toDecimalPlaces(3, Decimal.ROUND_DOWN);
};

export const calculateVolume = (weight: Decimal, cargo: RotationCargo, cargoTemperature: number): Decimal => {
    return calculateVolumeFromLitreWeight(weight, getCorrectedLitreWeight(cargoTemperature, cargo));
};

export const calculateWeight = (volume: Decimal, cargo: RotationCargo, cargoTemperature: number): Decimal => {
    return volume.times(getCorrectedLitreWeight(cargoTemperature, cargo));
};

type TemperatureField = 'litreWeightReferenceTemperature' | 'litreWeightCorrectionFactor' | 'litreWeight';

export const getTemperatureFieldValue = (fieldName: TemperatureField, cargo: RotationCargo): number => {
    return cargo.productChanges?.[fieldName] ?? cargo.product?.[fieldName];
};

export const getCorrectedLitreWeight = (cargoTemperature: number, cargo: RotationCargo): Decimal => {
    const adjustedTemperature = cargoTemperature - getTemperatureFieldValue('litreWeightReferenceTemperature', cargo);
    const correction = getTemperatureFieldValue('litreWeightCorrectionFactor', cargo) * adjustedTemperature;
    return new Decimal(getTemperatureFieldValue('litreWeight', cargo) - correction);
};
